import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { withViewportWidth } from 'decorators';
import { Card } from 'components/legacy/Card';
import AveragePricesHeader from './AveragePricesHeader';
import AveragePricesGraph from './AveragePricesGraph';

import './AveragePricesContent.scss';

export const enhance = withViewportWidth;

export function AveragePricesContent({ city, data, viewportWidth }) {
	const priceHistory = get(data, 'priceHistory', []);
	const avgPrice = get(data, 'averagePrice', '');
	const priceDifference =
		avgPrice - get(priceHistory, `[${priceHistory.length - 1}].price`, 0);
	return (
		<Card className="average-prices-content">
			<AveragePricesHeader
				city={city}
				totalReservations={get(data, 'totalReservations', 0)}
				avgPrice={avgPrice}
				priceDifference={priceDifference}
				historyLength={priceHistory.length}
			/>
			<AveragePricesGraph
				priceHistory={priceHistory}
				avgPrice={avgPrice}
				viewportWidth={viewportWidth}
			/>
		</Card>
	);
}

AveragePricesContent.propTypes = {
	city: PropTypes.string.isRequired,
	data: PropTypes.shape({
		averageMonthlyUnitPrice: PropTypes.shape({
			average_price: PropTypes.string,
			price_history: PropTypes.arrayOf(
				PropTypes.shape({
					date: PropTypes.string,
					price: PropTypes.number,
				}),
			),
		}),
	}).isRequired,
	viewportWidth: PropTypes.number.isRequired,
};

export default enhance(AveragePricesContent);
